





























import { CampaignFormData, NO_LIMIT } from '@tt4b/ttam-enums';
import { computed, defineComponent, PropType } from '@vue/composition-api';

const name = 'ttam-age';
export default defineComponent({
  name,
  props: {
    value: {
      type: Array as PropType<string[]>,
      default: () => [],
    },
    campaignData: {
      type: Object as PropType<CampaignFormData>,
      default: () => ({}),
    },
    options: {
      type: Array,
      default: () => [],
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    disabledTips: {
      type: String,
      default: '',
    },
  },
  setup(props, { emit }) {
    const _age = computed({
      get: () => {
        if (props?.value?.length === 0) {
          const noLimit = [NO_LIMIT];
          emit('input', noLimit);
          emit('change', noLimit);
          return noLimit;
        }
        return props.value;
      },
      set: val => {
        let newAge = val;
        const len = newAge?.length ?? 0;
        if (!len) {
          return;
        }
        // 选择不限时，清空其他限制条件
        if (len > 1) {
          const lastChecked = newAge[len - 1];
          if (lastChecked === NO_LIMIT) {
            newAge = [NO_LIMIT];
          } else {
            newAge = newAge.filter(item => item !== NO_LIMIT);
          }
        }
        emit('input', newAge);
        emit('change', newAge);
      },
    });
    return {
      _age,
      name,
    };
  },
});
